import React from "react";

const Faqs = () => {
  return (
    <div class="container">
      <section className="section faqs" id="faqs">
        <h2 className="text-center mb-3">Frequently Asked Questions</h2>
        <div className="col-lg-6 col-md-8 mx-auto text-center">
          <p className="mb-5">
            Have questions? We’ve got answers. Explore common queries and find
            out how our solution can work for you.
          </p>
        </div>

        <div className="row g-4">
          {/* Left Column */}
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="accordion" id="accordionLeft">
              <div className="accordion-item">
                <h2 className="accordion-header" id="leftHeading1">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#leftCollapse1"
                    aria-expanded="false"
                    aria-controls="leftCollapse1"
                  >
                    How does this Software work?
                  </button>
                </h2>
                <div
                  id="leftCollapse1"
                  className="accordion-collapse collapse"
                  aria-labelledby="leftHeading1"
                  data-bs-parent="#accordionLeft"
                >
                  <div className="accordion-body">
                    Our platform is a comprehensive solution for managing your
                    eCommerce site effortlessly. You can create products,
                    sliders, banners, and coupons through our intuitive
                    dashboard. Once you've set up your store, simply copy the
                    provided link, paste it into your site, and replace your
                    store ID. Our system handles the rest, including payment
                    processing and order management.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="leftHeading2">
                  <button
                    className="accordion-button collapsed flex-nowrap"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#leftCollapse2"
                    aria-expanded="false"
                    aria-controls="leftCollapse2"
                  >
                    Do I need technical knowledge to use this platform?
                  </button>
                </h2>
                <div
                  id="leftCollapse2"
                  className="accordion-collapse collapse"
                  aria-labelledby="leftHeading2"
                  data-bs-parent="#accordionLeft"
                >
                  <div className="accordion-body">
                    No, our platform is designed to be user-friendly and
                    accessible. You don't need any technical knowledge to set up
                    and manage your store. Our dashboard provides easy-to-follow
                    instructions, and you can reach out to our support team if
                    you need any assistance.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="leftHeading3">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#leftCollapse3"
                    aria-expanded="false"
                    aria-controls="leftCollapse3"
                  >
                    What payment methods are supported?
                  </button>
                </h2>
                <div
                  id="leftCollapse3"
                  className="accordion-collapse collapse"
                  aria-labelledby="leftHeading3"
                  data-bs-parent="#accordionLeft"
                >
                  <div className="accordion-body">
                    We support a range of payment methods, including PayPal,
                    Stripe, and Cash on Delivery (COD).
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="leftHeading4">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#leftCollapse4"
                    aria-expanded="false"
                    aria-controls="leftCollapse4"
                  >
                    How do I integrate with my existing eCommerce site?
                  </button>
                </h2>
                <div
                  id="leftCollapse4"
                  className="accordion-collapse collapse"
                  aria-labelledby="leftHeading4"
                  data-bs-parent="#accordionLeft"
                >
                  <div className="accordion-body">
                    Integration is simple. After setting up your store on our
                    platform, you'll receive a link to paste into your site,
                    replacing your store ID.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="leftHeading5">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#leftCollapse5"
                    aria-expanded="false"
                    aria-controls="leftCollapse5"
                  >
                    What types of products can I manage?
                  </button>
                </h2>
                <div
                  id="leftCollapse5"
                  className="accordion-collapse collapse"
                  aria-labelledby="leftHeading5"
                  data-bs-parent="#accordionLeft"
                >
                  <div className="accordion-body">
                    You can manage physical goods, digital items, and services —
                    plus sliders, banners, and promotional coupons.
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="accordion" id="accordionRight">
              <div className="accordion-item">
                <h2 className="accordion-header" id="rightHeading1">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#rightCollapse1"
                    aria-expanded="false"
                    aria-controls="rightCollapse1"
                  >
                    Is my data secure with this platform?
                  </button>
                </h2>
                <div
                  id="rightCollapse1"
                  className="accordion-collapse collapse"
                  aria-labelledby="rightHeading1"
                  data-bs-parent="#accordionRight"
                >
                  <div className="accordion-body">
                    Yes, we use industry-standard encryption and perform regular
                    security audits to protect your data.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="rightHeading2">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#rightCollapse2"
                    aria-expanded="false"
                    aria-controls="rightCollapse2"
                  >
                    Can I try free before committing?
                  </button>
                </h2>
                <div
                  id="rightCollapse2"
                  className="accordion-collapse collapse"
                  aria-labelledby="rightHeading2"
                  data-bs-parent="#accordionRight"
                >
                  <div className="accordion-body">
                    Yes, we offer a free 14-day trial so you can test all
                    features before subscribing.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="rightHeading3">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#rightCollapse3"
                    aria-expanded="false"
                    aria-controls="rightCollapse3"
                  >
                    How can I get support if I encounter issues?
                  </button>
                </h2>
                <div
                  id="rightCollapse3"
                  className="accordion-collapse collapse"
                  aria-labelledby="rightHeading3"
                  data-bs-parent="#accordionRight"
                >
                  <div className="accordion-body">
                    Contact our support via email, phone, or live chat — we
                    respond quickly.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="rightHeading4">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#rightCollapse4"
                    aria-expanded="false"
                    aria-controls="rightCollapse4"
                  >
                    Can I customize my store’s look and feel?
                  </button>
                </h2>
                <div
                  id="rightCollapse4"
                  className="accordion-collapse collapse"
                  aria-labelledby="rightHeading4"
                  data-bs-parent="#accordionRight"
                >
                  <div className="accordion-body">
                    Yes, you can change layout, colors, and branding to match
                    your style.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="rightHeading5">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#rightCollapse5"
                    aria-expanded="false"
                    aria-controls="rightCollapse5"
                  >
                    How do I cancel my subscription?
                  </button>
                </h2>
                <div
                  id="rightCollapse5"
                  className="accordion-collapse collapse"
                  aria-labelledby="rightHeading5"
                  data-bs-parent="#accordionRight"
                >
                  <div className="accordion-body">
                    You can cancel anytime via account settings — with refund
                    policies clearly outlined.
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="row pt-5">
            <div className="col-lg-9 col-md-9 col-sm-9 text-center mx-auto">
              <p className="text-danger fs-5">
                Ready to grow your business? Start your free trial today — no
                credit card required.
              </p>
              <a
                href="https://app.fexila.com/register"
                className="btn btn-primary"
                style={{ fontWeight: 600, width: "265px" }}
              >
                <img
                  src="assets/images/lock.png"
                  alt=""
                  style={{ display: "inline-block", marginRight: "6px" }}
                />
                Start your 14-day FREE trial
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Faqs;
